// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import { useEffect } from 'react';
import _debounce from 'lodash/debounce';

export const useKeyboardAvoidance = () => {
  useEffect(() => {
    let currentInput: HTMLElement | null = null;

    const handleFocus = ({ target }: FocusEvent) => {
      if (
        target instanceof HTMLElement &&
        (target.tagName === 'INPUT' ||
          target.tagName === 'TEXTAREA' ||
          target.tagName === 'SELECT' ||
          target.contentEditable === 'true')
      ) {
        currentInput = target;
      }
    };

    const handleBlur = () => {
      currentInput = null;
    };

    const scrollInputIntoView = _debounce(() => {
      currentInput?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 150);

    const handleResize = () => {
      if (currentInput) {
        scrollInputIntoView();
      }
    };

    document.addEventListener('focusin', handleFocus);
    document.addEventListener('focusout', handleBlur);
    window.visualViewport?.addEventListener('resize', handleResize);

    return () => {
      document.removeEventListener('focusin', handleFocus);
      document.removeEventListener('focusout', handleBlur);
      window.visualViewport?.removeEventListener('resize', handleResize);
      scrollInputIntoView.cancel();
    };
  }, []);
};
